<template>
  <div  v-if="card.info" class="card-header" v-loading="loading">
    <el-row type="flex" class="card-header-element" style="min-width:310px">
      <div class="card-header-element-icon"><i class="fas fa-calendar-alt"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Год карты целей</div>
        <div class="card-header-element-text-body">
          {{card.year}}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-id-card-alt"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Сотрудник</div>
        <div class="card-header-element-text-body">
          {{card.user.full_name}}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-briefcase"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Должность</div>
        <div class="card-header-element-text-body">
          {{ isCurrentYear ? card.user.position : card.info.position }}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-layer-group"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Бенд</div>
        <div class="card-header-element-text-body">
          {{ isCurrentYear ? card.user.band : card.info.band }}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-briefcase"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Дирекция</div>
        <div class="card-header-element-text-body">
          {{ isCurrentYear ? card.user.direction : card.info.direction }}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-warehouse"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Цех</div>
        <div class="card-header-element-text-body">
          {{ isCurrentYear ? card.user.workshop : card.info.workshop }}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-user-clock"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Возраст</div>
        <div class="card-header-element-text-body">
          {{ isCurrentYear ? card.user.age : card.info.age }}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-laptop"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Стаж</div>
        <div class="card-header-element-text-body">
          {{ card.user.experience }}
        </div>
      </div>
    </el-row>
    <el-row type="flex" class="card-header-element">
      <div class="card-header-element-icon"><i class="fas fa-building"/></div>
      <div class="card-header-element-text">
        <div class="card-header-element-text-header el-tag--plain el-tag--info">Непосредственный руководитель</div>
        <div class="card-header-element-text-body">
          <div v-if="card.user.chiefs && card.user.chiefs.direct">
            {{card.user.chiefs.direct.full_name}}
          </div>
        </div>
      </div>
    </el-row>





  </div>

</template>

<script>
import {mapGetters} from "vuex";
import ClickToEdit from "@/components/ClickToEdit.vue";
import {cardInfoField} from "@/mixins/cardInfoField";

export default {
  name: "card-header",
  components: {ClickToEdit},
  mixins:[cardInfoField],

  props: {},

  watch: {},
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card',
      loading: 'loading',
    }),
    isCurrentYear(){
      return this.card.year === (new Date()).getFullYear();
    },
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    getLastSubdivision(){
      for(let i=5; i>1; i--){
        if( this.card.user['subdivision_'+i] ){
          return this.card.user['subdivision_'+i];
        }
      }
      return '';
    }
  }
}
</script>


<style lang="scss">

.card-header {
  display: flex;
  gap: 3rem;
  justify-content: space-between;

  &-element {

    &-icon {
      margin-right:6px;

      i {
        padding: 12px;
        background-color: #F5F7FA;
        color: #8F9298;
        border-radius: 0;
      }
    }
  }
}

</style>